// src/utils/overlay.js
const api = {
  loading(message = "Procesando…", opts = {}) {
    if (window.overlay?.loading) return window.overlay.loading(message, opts);
    window.dispatchEvent(new CustomEvent("overlay:open", { detail: { mode: "loading", message, ...opts } }));
    return () => window.dispatchEvent(new CustomEvent("overlay:close"));
  },
  success(message = "Operación realizada", opts = {}) {
    if (window.overlay?.success) return window.overlay.success(message, opts);
    window.dispatchEvent(new CustomEvent("overlay:open", { detail: { mode: "success", message, ...opts } }));
  },
  error(message = "Ocurrió un error", opts = {}) {
    if (window.overlay?.error) return window.overlay.error(message, opts);
    window.dispatchEvent(new CustomEvent("overlay:open", { detail: { mode: "error", message, ...opts } }));
  },
  open(opts = {}) {
    if (window.overlay?.open) return window.overlay.open(opts);
    window.dispatchEvent(new CustomEvent("overlay:open", { detail: opts }));
  },
  close() {
    if (window.overlay?.close) return window.overlay.close();
    window.dispatchEvent(new CustomEvent("overlay:close"));
  },
};
export default api;
